import $ from 'cash-dom'
import loadingAttributePolyfill from 'loading-attribute-polyfill/dist/loading-attribute-polyfill.js'
import quicklink from 'quicklink/dist/quicklink.js'

import MainNav from './modules/main-nav'
import Ad from './modules/ad'
import ArchiveLoadMore from './modules/archive-load-more'
import AuthorSlider from './modules/author-slider'
import CommentForm from './modules/comment-form'
import IdleReload from './modules/idle-reload'
import PopupModal from './modules/popup-modal'

$(() => {
  quicklink.listen({
    ignores: [
      /wp\-login\.php/g
    ]
  })

  MainNav.init()
  Ad.init()
  ArchiveLoadMore.init()
  AuthorSlider.init()
  CommentForm.init()
  PopupModal.init()
  IdleReload.init()
})
